import { useStore } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import PaperPlaneIcon from '../../svgs/PaperPlaneIcon';

import type { OtherVideo } from '../../types.ts/story';

type Props = {
  video: OtherVideo;
  iconOnly?: boolean;
};

const ClientReadyFlag = observer(({ video, iconOnly = false }: Props) => {
  const userIdentityStore = useStore().userIdentityStore;
  const videoCreator = useVideoCreatorStore();
  const [isApproved, setIsApproved] = useState(video.isClientReady);

  useEffect(() => {
    setIsApproved(video.isClientReady);
  }, [video.isClientReady]);

  const toggleApprove = () => {
    setIsApproved(!video.isClientReady);
    videoCreator.updateIsClientReady(!video.isClientReady, video.id);
  };

  if (userIdentityStore.currentUserType === 'external') {
    return null;
  }

  return (
    <Container
      onClick={toggleApprove}
      isApproved={isApproved}
      iconOnly={iconOnly}
    >
      <PaperPlaneIcon
        width="14"
        height="14"
        strokeColor={
          isApproved ? (iconOnly ? '#F3E9D7' : '#03041A') : '#484848'
        }
      />
      {!iconOnly && <Status isApproved={isApproved}>APPROVED</Status>}
    </Container>
  );
});

const Container = styled.div<{
  isApproved?: boolean;
  iconOnly?: boolean;
}>`
  background: ${props => (props.iconOnly ? 'transparent' : '#f2d093')};
  border: ${props => (props.iconOnly ? 'none' : '1px solid #f2d093')};
  padding: ${props => (props.iconOnly ? '0' : '4px 8px')};
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: 0.2s ease;
  ${props =>
    !props.isApproved &&
    css`
      background: inherit;
      border-color: #484848;
    `}
  ${props =>
    props.iconOnly &&
    css`
      svg path {
        transition: 0.2s ease;
      }
    `}
`;

const Status = styled.div<{
  isApproved?: boolean;
}>`
  font-size: 10px;
  font-family: Inter;
  font-weight: 700;
  line-height: 10px;
  padding-left: 8px;
  color: #03041a;
  ${props =>
    !props.isApproved &&
    css`
      color: #484848;
      text-decoration: line-through;
    `}
`;

ClientReadyFlag.displayName = 'ClientReadyFlag';

export default ClientReadyFlag;
